import { PackagingRemittance } from '../../enums/packaging-remittance';

export interface IPackagingRemittanceComplianceData {
    complianceValue: PackagingRemittance,
    complianceDescription: string
}